
import React from "react";
import { useLanguage } from "@/contexts/LanguageContext";
import { useTournament } from "@/contexts/TournamentContext";
import { TournamentSelector } from "./TournamentSelector";
import { MexicanoTournament } from "./MexicanoTournament";
import { AmericanoTournament } from "./AmericanoTournament";
import { TeamAmericanoTournament } from "./TeamAmericanoTournament";

interface TournamentManagerProps {
  participants: any[];
  initialFormat?: string;
}

export const TournamentManager: React.FC<TournamentManagerProps> = ({ 
  participants, 
  initialFormat 
}) => {
  const { language } = useLanguage();
  
  // Add error boundary for tournament context
  let tournamentState;
  let resetTournament;
  
  try {
    const tournament = useTournament();
    tournamentState = tournament.tournamentState;
    resetTournament = tournament.resetTournament;
  } catch (error) {
    console.error('TournamentManager - Error accessing tournament context:', error);
    return (
      <div className="p-4 bg-red-50 border border-red-200 rounded-lg">
        <p className="text-red-700">
          {language === 'no' 
            ? 'Feil: Turneringskontekst ikke tilgjengelig' 
            : 'Error: Tournament context not available'}
        </p>
      </div>
    );
  }

  console.log('TournamentManager - tournamentState:', {
    isActive: tournamentState.isActive,
    currentRound: tournamentState.currentRound,
    tournamentType: tournamentState.tournamentType,
    isFinished: tournamentState.isFinished,
    isRoundActive: tournamentState.isRoundActive,
    hasMatches: tournamentState.americanoMatches?.length || 0,
    hasCourts: tournamentState.courts?.length || 0
  });

  // Check if any tournament is active or has started
  const isTournamentActive = tournamentState.isActive || tournamentState.currentRound > 0 || tournamentState.isFinished;
  
  // Special handling for team_americano - show component even if not active
  const shouldShowTeamAmericano = tournamentState.tournamentType === 'team_americano';
  
  console.log('TournamentManager - rendering decision:', {
    isTournamentActive,
    shouldShowTeamAmericano,
    tournamentType: tournamentState.tournamentType
  });

  // Render active tournament based on type
  if ((isTournamentActive && tournamentState.tournamentType) || shouldShowTeamAmericano) {
    console.log(`Rendering ${tournamentState.tournamentType} tournament`);
    
    if (tournamentState.tournamentType === 'mexicano') {
      return <MexicanoTournament participants={participants} />;
    } else if (tournamentState.tournamentType === 'americano') {
      return <AmericanoTournament participants={participants} />;
    } else if (tournamentState.tournamentType === 'team_americano') {
      return <TeamAmericanoTournament participants={participants} onBack={resetTournament} />;
    }
  }

  // Tournament selector hidden from public view - configured via /admin
  console.log('No active tournament, selector hidden from public view');
  return null;
};
